import { useEffect } from "react";
import { useStore } from "../../hooks/usestore";
import { observer } from "mobx-react-lite";
import * as THREE from "three";
import { Vector3 } from "three";

interface IProps {
    position: Vector3,
    color: string,
    intensity: number,
    distance: number,
}

const Light = ({ position, color, intensity, distance }: IProps) => {
    const { canvasStore: { scene } } = useStore();
    useEffect(() => {
        if (scene) {
            const light = new THREE.PointLight(color, intensity, distance);
            light.position.set(position.x, position.y, position.z);
            scene.add(light);
        }
    }, [scene])
    return (
        <></>
    )
}

export default observer(Light);